import { __exports as r } from "../../../../../../../../_virtual/c_popover_MinWidth2.js";
var e;
function p() {
  return e ? r : (e = 1, function(i) {
    i.__esModule = !0, i.c_popover_MinWidth = {
      name: "--pf-v6-c-popover--MinWidth",
      value: "auto",
      var: "var(--pf-v6-c-popover--MinWidth)"
    }, i.default = i.c_popover_MinWidth;
  }(r), r);
}
export {
  p as __require
};
